import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as ReceivedAlarms } from '@styles/icons/receivedAlarms.svg';
import React from 'react';

export const ReceivedAlarmsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={ReceivedAlarms} viewBox={'0 0 19 19'} />
);

export default ReceivedAlarmsIcon;
